import React from "react"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import ReactHtmlParser from "react-html-parser"
import Svg from "../_svgs/svg"
import useWindowWidth from "../../hooks/useWindowWidth"

export default function ImpressionBlockComponent({
  icon,
  desktopImage,
  mobileImage,
  opacity,
  title,
  introText,
  readMoreUrl,
  readMore,
  label,
  bottomPadding,
  topPadding,
  target,
}) {
  const iconSrc = SelectionFactoryHelper.getFromSelectionFactory(icon)
  const windowWidth = useWindowWidth()
  const tp = SelectionFactoryHelper.getFromSelectionFactory(topPadding)
  const bp = SelectionFactoryHelper.getFromSelectionFactory(bottomPadding)

  const mobileImageExists = mobileImage !== undefined ? true : false
  var imgSrc = desktopImage
  const opacityStyle = { opacity: opacity } // Apply opacity from prop
  if (mobileImageExists && windowWidth < 768) {
    imgSrc = mobileImage
  }

  return (
    <div className={`impression-block-container ${tp ? tp : ""} ${bp ? bp : ""} ${windowWidth < 768 ? "mobile-background" : ""}`}>
      <div className="w--normal">
        <picture className="background-pic">
          <source media="(max-width:767px)" srcSet={imgSrc} />
          <img src={imgSrc} alt="" />
        </picture>
        <div className="opacity-layer" style={opacityStyle}></div>
        <div className="text-layer">
          <div className="content">
            <div className="icon">
              <Svg iconName={iconSrc} fillColor={"none"} stroke={"#FFF"} />
            </div>
            <div className="category">{label}</div>
            <div data-epi-property="Title" className="rich-text">
              {ReactHtmlParser(title)}
            </div>
            <div data-epi-property="IntroText" className="rich-text">
              {ReactHtmlParser(introText)}
            </div>
            <a target={target[0]?.value || "_blank"} className="button" href={readMoreUrl}>
              {readMore}
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
